import React from 'react';
import PropTypes from 'prop-types';
import CheckboxInput from '../formComponents/CheckboxInput';
import LoadableSubmit from '../loadableComponents/LoadableSubmit';
import Translate from '../Translate';
import {AGENCY_SIGNON} from '../../constants/SalesChannels';
import {supportedProductCodes} from '../../constants/supportedProductCodes';

const BookingOverviewConfirm = (props) => {
  let payButtonText = [ 'BANK', 'SEPA'].includes(props.paymentOptionSelected)
    ? 'Book'
    : 'Continue';
  let termsLinkText;
  let product;
  const onTermsAccept = () => props.acceptTerms();

  const termsArgs = {
    '!astart': `<a href="${props.termsAndConditionsLink}" target="_blank">`,
    '!aend': '</a>',
  };

  const sendBookEvent = () => {
    if (product && window.dataLayer) {
      const eventname = "sbook755_book_property_" + product.productCode;
      window.dataLayer.push({'event':eventname});
    }
  }

  const submitForm = () => {
    props.startSubmitLoading(true);
    sendBookEvent();
    return props.paymentValidate();
  };

  if (props.request) {
    payButtonText = 'Request booking now';
    termsLinkText = 'I confirm that the registered information is correct and that I have read and agree with the !astartrental terms!aend. By confirming the booking, I am committed to pay the full amount if the booking is confirmed within 3 days. The request then automatically becomes a confirmed booking.';
  }
  else if (props.salesChannel === AGENCY_SIGNON) {
    payButtonText = 'Book now';
    termsLinkText = 'I confirm that the registered information is correct and that I have read and agree with the !astartrental and payment terms!aend. By confirming the booking, I agree to book the holiday for the customer and I am committed to paying the amount required.';
  }
  else if (props.isCreditAgency || props.agencyOptionBooking) {
    payButtonText = 'Book now';
    // EC-858 - Same text here as if salesChannel is AGENCY_SIGNON, but a new text for these two logic condition is currently being produced by the legal department.
    termsLinkText = 'I confirm that the registered information is correct and that I have read and agree with the !astartrental and payment terms!aend. By confirming the booking, I agree to book the holiday for the customer and I am committed to paying the amount required.';
  }
  else {
    termsLinkText = 'I confirm that the registered information is correct and that I have read and agree with the !astartrental terms!aend. Furthermore I confirm I am at least 18 years of age (for group bookings at least 21 years).';
  }

  // We're dealing with a product (not a novasol house)
  if (product = supportedProductCodes.find(x => x.productCode === props.productCode)) {
    if (product.bookingTxt) {
      payButtonText = product.bookingTxt;
    }

    if (product.termsLinkText) {
      termsLinkText = product.termsLinkText;
    }
  }

  const wrapperClass = ['booking-overview__actions'];
  if (props.disabled) {
    wrapperClass.push('disabled-area');
  }

  const termClasses = ['booking-overview__terms'];
  if (props.errors.termsAndConditions) {
    termClasses.push(`${termClasses[0]}--error`);
  }

  return (
    <div className={wrapperClass.join(' ')}>
      <div className={termClasses.join(' ')}>
        <CheckboxInput autoComplete="off" name="acceptTerms" onChange={onTermsAccept} value={props.acceptedTermsAndConditions} />
        <label htmlFor="acceptTerms">
          <Translate
            args={termsArgs}
            content={termsLinkText}
          />
        </label>
      </div>

      <LoadableSubmit
        className="booking-overview__confirm"
        content={payButtonText}
        hasLongText={props.hasLongText}
        loadingWrapClass="loading-wrap-confirmation"
        onClick={submitForm}
      />

      <div className="booking-overview__notes">
        <i className="fa fa-lock" />
        <Translate
          component="span"
          content="Since encrypted, your personal information is kept confidential."
        />
      </div>
    </div>
  );
};

BookingOverviewConfirm.PropTypes = {
  acceptedTermsAndConditions:PropTypes.bool.isRequired,
  paymentOptionSelected:PropTypes.string.isRequired,
  paymentValidate:PropTypes.func.isRequired,
  acceptTerms:PropTypes.func.isRequired,
  termsAndConditionsLink:PropTypes.string.isRequired,
  isCreditAgency:PropTypes.bool.isRequired,
  agencyOptionBooking:PropTypes.bool.isRequired,
  request:PropTypes.bool.isRequired,
  errors:PropTypes.shape({
    termsAndConditions:PropTypes.string,
  }),
  disabled:PropTypes.bool.isRequired,
  startSubmitLoading:PropTypes.func.isRequired,
  isSubmitLoading:PropTypes.bool.isRequired,
  salesChannel:PropTypes.string.isRequired,
  hasLongText:PropTypes.bool,
};

export default BookingOverviewConfirm;
